import { Requester } from './Requester';
import { IUserDocumentPopulated } from '../types';

export const PostUser = async ({
    name,
    email,
    role,
    preferredLang
}: {
    name: string;
    email: string;
    role: string;
    preferredLang: string;
}): Promise<IUserDocumentPopulated | null> => {
    try {
        const response = await Requester<{ user: IUserDocumentPopulated } | null>({
            path: `users/admin/user`,
            method: 'POST',
            payload: {
                name,
                role,
                preferredLang,
                email: (email ?? '').trim()
            }
        });

        return response && 'user' in response ? (response.user as IUserDocumentPopulated) : null;
    } catch (e) {
        console.error('Create user request failed');
        return Promise.reject(e);
    }
};
